import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalVariable } from 'app/main/globals';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AspClutchKitDetailsService {

  constructor(  private http: HttpClient,) { }

  getClutchSuggestions(
    relevancyCount,
    variant,
    partNames,
    garageKey,
    regNo
  ): Observable<any> {

    const headers = new HttpHeaders({
      'x-api-key': `${GlobalVariable.AUTOVERSE_ELASTIC_KEY}`,
    });

    const partNameValue = partNames || 'String';
    const variantValue = variant || 'String';
    const userType = localStorage.getItem('userType');

    return this.http.get(
      `${GlobalVariable.BASE_API_URL_ELASTIC}/part-name-suggestions-warehouse` +
      `?partNames=${partNameValue}` +
      `&variant=${variantValue}` +
      `&relevancyCount=${relevancyCount}` +
      `&garageKey=${garageKey}` +
      `&regNo=${regNo}` +
      `&instantDelivery=1` +
      `&userKey=${localStorage.getItem('spareUserKey')}` +
      `&source=web` +
      `&userType=${userType}` +
      `&autoverseCredit=false`,
      { headers }
    );
  }
  instantOrder(payload: any) {

    return this.http.post(
      `${GlobalVariable.BASE_API_URL_ELASTIC}/order/instantOrder`,
      payload,
      {
        headers: new HttpHeaders({
          'x-api-key': `${GlobalVariable.AUTOVERSE_ELASTIC_KEY}`,
          'Content-Type': 'application/json'
        })
      }
    );
  }
  createQuotation(requestBody: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post(`${GlobalVariable.BASE_API_URL_SPARES}`+'/spare/request/create/quotation', requestBody, { headers });
  }
    getSpareRequest(type: string, spareGarageId: string, requestId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${GlobalVariable.BASE_API_URL}/b2bgetsparerequest?type=${type}&spareGarageId=${spareGarageId}&requestId=${requestId}`;

    return this.http.post(url, {}, { headers });
  }
  createKitSearchFailure(payload: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8',
      'x-api-key': '0685c929fe579454904f6ca97a6ab0b3'
    });

    return this.http.post(
      `${GlobalVariable.BASE_API_URL_ELASTIC}/kit-search-failue/create`,
      payload,
      { headers }
    );
  }
}
